import styled from '@emotion/styled';
import { TableCell, TableRow as MuiTableRow, Box, Typography, Pagination, Select } from '@mui/material';

export const StyledTableCell = styled(TableCell)<any>(
  ({ theme, sortDirection }) => ({
    color: `${
      theme?.palette?.neutral?.greyText ||
      theme?.palette?.text?.primary ||
      '#333'
    } !important`,
    backgroundColor: `${
      theme?.palette?.background?.paper || '#fff'
    } !important`,
    border: '1px solid #EDF2F7',
    padding: '10px 16px',

    '& .actions': {
      opacity: sortDirection ? 1 : 0,
      transition:
        theme?.transitions?.create?.('opacity') || 'opacity 0.3s ease',
      width: 56,
      display: 'flex',
      justifyContent: 'flex-start',
      gap: theme?.spacing?.(0.5) || '4px',
      color:
        theme?.palette?.neutral?.greyText ||
        theme?.palette?.text?.secondary ||
        '#666',
      backgroundColor: theme?.palette?.background?.paper || '#fff',
    },
    '&:hover .actions': {
      opacity: 1,
    },
  })
);

export const StyledBodyCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== '$cellwidth',
})<{ $cellwidth?: string }>(({ $cellwidth }) => ({
  border: '1px solid #EDF2F7',
  backgroundColor: 'transparent',
  padding: '4px 16px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: 12,
  ...(!!$cellwidth && {
    width: $cellwidth,
    minWidth: $cellwidth,
    maxWidth: $cellwidth,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
}));

export const PaginationContainer = styled(Box)(({ theme }: any) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: `${theme?.palette?.background?.paper || '#fff'}`,
  padding: 16,
}));

export const PaginationText = styled(Typography)<{ fontSize?: number }>`
  font-size: ${({ fontSize }): number => fontSize ?? 14}px;
  font-weight: 400;
  color: #7a7a9d;
`;

export const PaginationControls = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
});

export const RowsPerPageContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

export const StyledCheckboxCell = styled(TableCell)(() => ({
  border: '1px solid #EDF2F7',
  padding: '0px 8px',
  width: '48px',
  minWidth: '48px',
}));

export const TooltipCell = styled(Box)({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const StyledPagination = styled(Pagination)`
  .MuiPaginationItem-root {
    font-size: 12px;
    color: #6c737f;
  }
`;

export const StyledSelect = styled(Select)`
  .MuiSelect-select {
    padding: 4px 8px;
    font-size: 12px;
    min-height: unset;
  }
`;

export const SkeletonCell = styled(TableCell)(({ theme }: any) => ({
  padding: theme.spacing(1.5),
  '& .MuiSkeleton-root': {
    height: '20px',
    borderRadius: theme.shape.borderRadius,
  },
}));

export const StyledTableRow = styled(MuiTableRow, {
  shouldForwardProp: (prop) => prop !== '$clickable',
})<{ $clickable?: boolean }>`
  ${({ $clickable }): string =>
    $clickable
      ? `
cursor: pointer;
background-color:transparent;
&:hover {
background-color: rgba(0, 0, 0, 0.04);
}
`
      : ` &:hover {
background-color: rgba(0, 0, 0, 0.04);
}`}
`;
